import BaseCtrl from 'edge/platform/base/BaseCtrl';
import DateUtil from 'gw-portals-util-js/DateUtil';
import _ from 'underscore';

var fn = function fn($scope, submissionViewModel, $filter, CPPQuoteUtilService, CppFlowConstants) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    // This function is used to remove prefill data entered through guidance to product account and submission creation.
    if (submissionVM.baseData.accountHolder.value) {
        if (submissionVM.baseData.accountHolder.value.soleProprietorship_AMA === undefined) {
            submissionVM.baseData.accountHolder.value.subtype = 'Company';
            submissionVM.baseData.accountHolder.value.soleProprietorship_AMA = false;
        }
    }

    CPPQuoteUtilService.getAvailableAMACPPClassCodes().then(function (success) {
        if (success) {
            //reset array. Avoids putting duplicate values.
            CppFlowConstants.CPPGLCodes_AMA.length = 0;
            success.forEach(function (item) {
                CppFlowConstants.CPPGLCodes_AMA.push(item);
            });
        }
    });

    ctrl.init = function () {

        $scope.placeholders = {
            firstname: $filter('translate')('ama.quoteandbind.cpp.views.First Name'),
            lastname: $filter('translate')('ama.quoteandbind.cpp.views.Last Name'),
            postalcode: $filter('translate')('ama.quoteandbind.cpp.views.Postal Code')
        };

        $scope.nextButtonConfig = {
            class: 'button'
        };

        /**
         * Create a date object to use to dynamically generate dates to fill out drop downs for date of birth
         */
        $scope.dates = {};

        // Fill out years; Since 1918 take current year - 18 to get most recent year as per requirements.
        $scope.dates.years = [];
        for (var i = new Date().getFullYear() - 18; i >= 1918; i--) {
            $scope.dates.years.push(i);
        }

        // Fill out all days to 31. Will selectively filter the days depending on which month is selected.
        $scope.dates.days = [];
        for (var _i = 1; _i <= 31; _i++) {
            $scope.dates.days.push(_i);
        }

        // Static month objects.

        $scope.dates.months = [{ id: 0, name: $filter('translate')('ama.quoteandbind.cpp.views.month.January') }, { id: 1, name: $filter('translate')('ama.quoteandbind.cpp.views.month.February') }, { id: 2, name: $filter('translate')('ama.quoteandbind.cpp.views.month.March') }, { id: 3, name: $filter('translate')('ama.quoteandbind.cpp.views.month.April') }, { id: 4, name: $filter('translate')('ama.quoteandbind.cpp.views.month.May') }, { id: 5, name: $filter('translate')('ama.quoteandbind.cpp.views.month.June') }, { id: 6, name: $filter('translate')('ama.quoteandbind.cpp.views.month.July') }, { id: 7, name: $filter('translate')('ama.quoteandbind.cpp.views.month.August') }, { id: 8, name: $filter('translate')('ama.quoteandbind.cpp.views.month.September') }, { id: 9, name: $filter('translate')('ama.quoteandbind.cpp.views.month.October') }, { id: 10, name: $filter('translate')('ama.quoteandbind.cpp.views.month.November') }, { id: 11, name: $filter('translate')('ama.quoteandbind.cpp.views.month.December') }];

        // Upon new form date of birth values are not defined. define it as an empty object.
        if (!angular.isDefined(submissionVM.baseData.accountHolder.dateOfBirth.value)) {
            submissionVM.baseData.accountHolder.dateOfBirth.value = {};
        }

        $scope.accountHolder = submissionVM.baseData.accountHolder.value;
        $scope.accountHolder.primaryPhoneType = null;
        submissionVM.baseData.policyAddress.addressType.value = submissionVM.baseData.policyAddress.addressType.value || 'home';
        $scope.submissionVM = submissionVM;
        $scope.postalCodeReadonly = angular.isDefined($scope.submissionVM.baseData.policyAddress.postalCode.value);
        $scope.stateReadonly = angular.isDefined($scope.submissionVM.baseData.policyAddress.state.value);

        $scope.hidePolicyAddressFields = ['AddressLine1', 'AddressLine2', 'AddressLine3', 'City', 'State'];

        $scope.today = DateUtil.currentDateAtMidnight();

        /**
         * This is the filter day. Will show/hide proper days depending on the month selected.
         * @param {*} day
         */
        $scope.filterByMonth = function (day) {

            if (day === 29 && $scope.tempDate.month === 1 && ctrl.isLeapYear($scope.tempDate.year)) {
                return true;
            } else if (day > 28 && $scope.tempDate.month === 1) {
                return false;
            } else if (day === 31 && [3, 5, 8, 10].indexOf($scope.tempDate.month) !== -1) {
                return false;
            }
            return true;
        };

        $scope.tempDate = {
            day: $scope.submissionVM.baseData.accountHolder.dateOfBirth.day.value || null,
            month: angular.isNumber($scope.submissionVM.baseData.accountHolder.dateOfBirth.month.value) ? $scope.submissionVM.baseData.accountHolder.dateOfBirth.month.value : null,
            year: $scope.submissionVM.baseData.accountHolder.dateOfBirth.year.value || null
        };

        $scope.$watch('tempDate.day', function (newValue) {
            if (newValue) {
                $scope.submissionVM.baseData.accountHolder.dateOfBirth.day.value = newValue;
            }
        });
        $scope.$watch('tempDate.month', function (newValue) {
            if (newValue !== null) {
                $scope.submissionVM.baseData.accountHolder.dateOfBirth.month.value = newValue;
            }
        });
        $scope.$watch('tempDate.year', function (newValue) {
            if (newValue) {
                $scope.submissionVM.baseData.accountHolder.dateOfBirth.year.value = newValue;
            }
        });

        $scope.$watch('submissionVM.baseData.policyAddress.postalCode.value', function (newValue, oldValue) {
            if (newValue && newValue.replace(' ', '').length == 6) {
                if (!new RegExp('[tT][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$').test(newValue)) {
                    $scope.invalidPostalCode = $filter('translate')('quoteandbind.pa.directives.templates.pa-quick-address-info.Invalid postal code');
                    $scope.postalCodeValidity = false;
                } else {
                    $scope.invalidPostalCode = undefined;
                    $scope.postalCodeValidity = undefined;
                }
            } else if (newValue && newValue.replace(' ', '').length != 6) {
                $scope.invalidPostalCode = $filter('translate')('quoteandbind.pa.directives.templates.pa-quick-address-info.Invalid postal code');
                $scope.postalCodeValidity = false;
            }
        });
    };
    /**
               * Leap year calculation
               */
    ctrl.isLeapYear = function (year) {

        if (year === '' || year === 0 || year === null) {
            return null;
        }

        if (year % 4 === 0) {
            if (year % 100 !== 0) {
                return true;
            } else {
                if (year % 400 !== 0) {
                    return false;
                } else {
                    return true;
                }
            }
        }
        return false;
    };

    /**
     * Method that grabs GW validation messages and merges them into one array for better displaying.
     *
     */
    ctrl.evalDOB = function () {
        var errorMessages = [];
        /*$scope.submissionVM.baseData.accountHolder.dateOfBirth.day.aspects.validationMessages.forEach(message => {
            errorMessages.push(message);
        });
        $scope.submissionVM.baseData.accountHolder.dateOfBirth.month.aspects.validationMessages.forEach(message => {
            errorMessages.push(message);
        });
        $scope.submissionVM.baseData.accountHolder.dateOfBirth.year.aspects.validationMessages.forEach(message => {
            errorMessages.push(message);
        });*/

        //This isn't actually going to fix the issue of GW clearing the validation messages. It just displays the message. Need further insite on this.
        if ($scope.tempDate.day === null || $scope.tempDate.month === null || $scope.tempDate.year === null) {
            if (errorMessages.indexOf($filter('translate')('policycommon.This is a required field')) === -1) {
                errorMessages.push($filter('translate')('policycommon.This is a required field'));
            }
        }

        //Clear out duplicate values.
        return _.uniq(errorMessages);
    };

    ctrl.turnOnSoleProprietorship_AMA = function () {
        $scope.accountHolder.soleProprietorship_AMA = true;

        $scope.accountHolder.subtype = 'Person';
        // Review with business
        $scope.accountHolder.occupation = 'BusinessOwner';
    };
    ctrl.turnOffSoleProprietorship_AMA = function () {
        $scope.accountHolder.soleProprietorship_AMA = false;
        $scope.accountHolder.subtype = 'Company';
    };

    ctrl.next = function (callback, form) {
        var isValid = form.valid;

        if (submissionVM.lobData.commercialPackage.generalLiability != undefined) {
            if (submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.totalRevenue.amount.value == undefined) {
                submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.totalRevenue = null;
                submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.canceled.value = true;
            }
            if (submissionVM.lobData.commercialPackage.yearBusiness.value == null) {
                submissionVM.lobData.commercialPackage.canceled.value = true;
            }
        }

        if ($scope.tempDate.day === null || $scope.tempDate.month === null || $scope.tempDate.year === null) {
            isValid = false;
        }

        if (!new RegExp('[tT][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$').test(submissionVM.baseData.policyAddress.postalCode.value)) {
            $scope.invalidPostalCode = $filter('translate')('quoteandbind.pa.directives.templates.pa-quick-address-info.Invalid postal code');
            $scope.postalCodeValidity = false;
            isValid = false;
        } else {
            $scope.invalidPostalCode = undefined;
            $scope.postalCodeValidity = undefined;
        }

        callback(submissionVM, {
            valid: isValid
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'submissionViewModel', '$filter', 'ama.CPPQuoteUtilService', 'ama.CppFlowConstants'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/controllers/CPPContactDetailsCtrl.js
// module id = 823
// module chunks = 0